// What a downgrade changes on public pages (PRD 9.7), item by item, from the API's over-limit items
// ({key, allowed, current, label}): before the date, everything that will change; afterwards, what has changed.
// public_scope (backend/access.py) keeps the oldest brands, forms and widgets and the first published testimonials
// within the plan, shows other layouts as a grid and brings the TrustClap credit back; seat_paused ends access for
// the teammates who joined last.
import { formatDate, listText } from './format';

function only(item, noun, which, future, present, enforced) {
  const verb = enforced ? present[item.allowed === 1 ? 0 : 1] : future;
  return 'only ' + item.allowed + ' of your ' + item.current + ' ' + noun + ' (' + which + ') ' + verb;
}

function seats(item, enforced) {
  const keep = Math.max(0, item.allowed - 1);
  if (!keep) return enforced ? 'your teammates have lost access' : 'your teammates will lose access';
  const who = keep === 1 ? 'the teammate who joined first' : 'the first ' + keep + ' teammates to join';
  return 'only ' + who + (enforced ? (keep === 1 ? ' has' : ' have') + ' access' : ' will keep access');
}

export function overLimitEffects(state) {
  const enforced = !!(state && state.enforced);
  return ((state && state.items) || []).map(item => {
    if (item.key === 'brands') return only(item, 'brands', 'the oldest', 'will stay public', ['is public', 'are public'], enforced);
    if (item.key === 'forms') {
      return only(item, 'collection forms', 'the oldest', 'will take responses', ['takes responses', 'take responses'], enforced);
    }
    if (item.key === 'widgets') {
      return only(item, 'widgets', 'the oldest', 'will show testimonials', ['shows testimonials', 'show testimonials'], enforced);
    }
    if (item.key === 'published') {
      return only(item, 'published testimonials', 'the first published', 'will show', ['shows', 'show'], enforced);
    }
    if (item.key === 'seats') return seats(item, enforced);
    if (item.key === 'layouts') return enforced ? 'other layouts show as a grid' : 'other layouts will show as a grid';
    if (item.key === 'remove_branding') {
      return enforced ? 'the TrustClap credit is back on your pages' : 'the TrustClap credit will come back on your pages';
    }
    return item.label + ' (' + item.current + (typeof item.allowed === 'number' ? ', ' + item.allowed + ' on the plan' : '') + ')';
  });
}

// The app-wide banner: the whole effect in one sentence, so nobody is surprised on the date.
export function overLimitText(state, planLabel) {
  if (!state) return '';
  const label = planLabel || 'Free';
  const effects = listText(overLimitEffects(state));
  if (state.enforced) {
    return 'Your workspace is over the ' + label + ' plan\'s limits' + (effects ? ', so ' + effects : '')
      + '. Choose what stays public, or upgrade.';
  }
  return 'Your workspace is over the ' + label + ' plan\'s limits. Nothing has changed publicly yet. From '
    + formatDate(state.effective_on) + ' ' + (effects || 'only what fits the ' + label + ' plan will show')
    + '. Choose what stays public, or upgrade.';
}
